var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6112 2.21C12.2512 1.93 11.7513 1.93 11.3913 2.21C9.49126 3.66 3.88125 8.39 3.91125 13.9C3.91125 18.36 7.54126 22 12.0113 22C16.4813 22 20.1112 18.37 20.1112 13.91C20.1212 8.48 14.5012 3.67 12.6112 2.21ZM12.8998 9.77731C12.8998 9.28855 12.5036 8.89233 12.0148 8.89233C11.5261 8.89233 11.1299 9.28855 11.1299 9.77731V13.2243C11.1299 13.7131 11.5261 14.1093 12.0148 14.1093C12.5036 14.1093 12.8998 13.7131 12.8998 13.2243V9.77731ZM12.0095 15.2893C11.4077 15.2893 10.9199 15.7771 10.9199 16.3789C10.9199 16.9806 11.4077 17.4684 12.0095 17.4684H12.0168C12.6186 17.4684 13.1064 16.9806 13.1064 16.3789C13.1064 15.7771 12.6186 15.2893 12.0168 15.2893H12.0095Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDefault);
export default __webpack_public_path__ + "static/media/alert-default.300370753502c8c4870a0289a457d5ed.svg";
export { ForwardRef as ReactComponent };